// MODULES
import React from "react";
import moment from "moment";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';

import Card from "@cobComponents/Card";
import countries from "@helpers/countries";

const CustomerInformationCard = props => {
  const { client, toggleAddCustomerModal } = props;

  const { street, city, email, phone_alternative } = client;
  const phoneNumber = client.phone || client.phoneNumber;
  const zipCode = client.postal_code || client.zipCode;
  const countryCode = client.country_code || client.country;
  const country = countryCode ? countries.find(country => country.code === countryCode).label : "-";
  const lastSignedDocument = client.last_signed_document || client.lastSignedDocument;

  let latestAdviceDate = null,
    wasUpdatedToday = false,
    wasUpdatedYesterday = false,
    daysSinceUpdated = 0;

  if (lastSignedDocument) {
    latestAdviceDate = moment(lastSignedDocument, "YYYY-MM-DD");
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');
  
    wasUpdatedToday = latestAdviceDate.isSame(today, 'd');
    wasUpdatedYesterday = latestAdviceDate.isSame(yesterday, 'd');

    // If not today or yesterday, get how many days ago
    if (!wasUpdatedToday && !wasUpdatedYesterday) {
      daysSinceUpdated = moment().diff(latestAdviceDate, 'days');
    }
    
    // Format latestAdviceDate
    latestAdviceDate = latestAdviceDate.format("YYYY-MM-DD");
  }

  return (
    <Card 
      title="Kundinformation"
      icon={PersonIcon}
      sxStyle={{
        mt: {xs: 2, md: 0},
      }}
    >
        <Box sx={{
          height: 0,
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          top: -31
        }}>
          <Link 
            component="button"
            type="button"
            onClick={toggleAddCustomerModal}
            sx={{
              color: "inherit",
              cursor: "pointer"
            }}>
            <EditIcon sx={{fontSize: "14px", color: "primary.main"}}/>
          </Link>
        </Box>
        <Box sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          mt: 0.6
        }}>
          <Typography color="inherit" variant="body2" sx={{width: "48%"}}>
            <b>Telefon:</b>
          </Typography>                                
          <Typography color="inherit" variant="body2" align="right" sx={{width: "48%"}}>
            {phoneNumber}<br/>
            {phone_alternative}
          </Typography>
        </Box>
        <Box sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          mt: 0.6
        }}>
          <Typography color="inherit" variant="body2" sx={{width: "48%"}}>
            <b>E-postadress:</b>
          </Typography>
          <Typography noWrap color="inherit" variant="body2" align="right" sx={{width: "48%"}}>
            <Link
            href={`mailto:${email}`}
            >
              {email}
            </Link>                                
          </Typography>
        </Box>
        <Box sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mt: 0.6
        }}>
          <Typography color="inherit" variant="body2" sx={{width: "48%"}}>
            <b>Adress</b>
          </Typography>                                
          <Typography color="inherit" variant="body2" align="right" sx={{width: "48%"}}>
            {street || "-"} <br/>
            {zipCode || city ? zipCode + " " + city : "-" }  <br/>
            {country}
          </Typography>                       
        </Box>
        <Box sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mt: 1.8
        }}>
          <Typography color="inherit" variant="body2" sx={{width: "48%"}}>
            <b>Senaste rådgivning</b>
          </Typography>                                
          <Typography color="inherit" variant="body2" align="right" sx={{width: "48%"}}>
            {latestAdviceDate && (
              <React.Fragment>
                {latestAdviceDate}<br/>
                {wasUpdatedToday ? "Idag" : wasUpdatedYesterday ? "Igår" : `${daysSinceUpdated} dagar sedan`}
              </React.Fragment>            
            )}
          </Typography>                       
        </Box>
    </Card>
  );
};

export default CustomerInformationCard;